const config = {
    url: process.env.REACT_APP_API_URL ?? '',
};

export default config;
